import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/styles";
import { Typography, Button } from "@material-ui/core";
import Card from "components/cards/Card";
import { asDate3 } from "utils/text";
import { useHistory } from 'react-router-dom';

export default function EventCard ({ data }) {
  const history = useHistory();
  const classes = useStyles();
  const TextAbstract = (text, length) =>{
    if (text == null) {
        return "";
    }
    if (text.length <= length) {
        return text;
    }
    text = text.substring(0, length);
    let last = text.lastIndexOf(" ");
    text = text.substring(0, last);
    return text + "...";
  }  
  return (
    <Card contentStyle={clsx(classes.content)} className={classes.root}>
      <div className={classes.imageContainer}>
        <img
          alt="event img"
          className={classes.eventImage}
          src={data.image}
          style={{ 
            backgroundImage: `url(${data.image})` 
          }} 
        />
      </div>
      <div className={classes.contect}>
        <div className={classes.eventDate}>
          <span className={classes.dateText}>
            {asDate3(data.start_at)}
          </span>
        </div>
        <div className={classes.header}>
          <Typography component="h2" variant="h6" className={classes.title}>
            {TextAbstract(data.title,75)}
          </Typography>
        </div>
        <div className={clsx(classes.body)}>
          <Typography className={clsx(classes.textMain)} dangerouslySetInnerHTML={{ __html: TextAbstract(data.description,80)}} />
        </div>
        <Button
          variant="contained"
          fullWidth
          color="primary"
          className={classes.btn}
          onClick={() => {
            history.push(`/event/detail/${data.id}`, {
              query: {
                type: 'event'
              }
            })
          }}
        >
          Learn More
        </Button>
      </div>
    </Card>
  );
};

const useStyles = makeStyles((theme) => ({
  imageContainer: {
    // height: 182,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderBottom: '1px solid #e9ecf0',
  },
  contect:{
    padding: '20px 20px 0px',
  },
  eventImage:{
    maxWidth: "100%",
    width: '100%',
    height: '217px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    backgroundAttachment: 'fixed',
    objectFit: 'cover',
  },
  textMain:{
    fontSize:14,
  },
  content: {
    padding: theme.spacing(0),
  },
  divider: {
    marginTop: 10,
  },
  btn:{
    backgroundColor: '#05C1FF !important',
    color : '#fff !important',
  },
  dateText : {
    textAlign: 'center',
    display: 'block',
    marginTop: '10px',
    marginLeft: '5px',
    color: 'white',
    fontWeight: '700',
    fontSize: '14px'
  },
  root: {
    border: '1px solid #E5E9F2',
    boxShadow: 'none',
    borderRadius:10,
    position:'relative',
    height: "100%",
  },
  eventDate:{
    display: 'inline-block !important',
    width: '160px',
    height: 0,
    boxSizing: 'content-box',
    borderLeft: 'calc(0px/2) solid transparent',
    borderRight: 'calc(35px/2) solid transparent',
    borderBottom: '35px solid #05C1FF',
    position: 'absolute',
    top: '182px',
    left: 0,
  },
  header: {
    // display: "flex",
    // justifyContent: "space-between",
  },
  title: {
    fontSize: 16,
    fontWeight: 600,
  },
  author: {
    fontSize: 14,
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
    marginBottom: 5,
  },
  body: {
    marginTop: 8,
    fontWeight: "normal",
    textAlign: "initial",
    overflowX: 'auto',
    marginBottom: 10,
    fontSize:14,
    height: '54%',
    '&::-webkit-scrollbar': {
      width: 3,
    },
    '&::-webkit-scrollbar-track': {
      '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#8c8c8c',
      borderRadius: '4px'
    },
  },
  authorright: {
    display: 'flex',
    alignItems: 'center',
  },
  authorname: {
    color: '#ADB0C2',
    fontSize: 12
  },
  footer: {
    display: "flex",
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  },
  street: {
    marginLeft: theme.spacing(3),
    fontSize: 14,
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
    }
  },
  address: {
    fontSize: 14,
  },
  venueContainer: {
    padding: '12px 0px 2px',
  },
  venueBox: {
    display: 'flex',
    paddingBottom: 10,
    alignItems: 'flex-start',
  },
  venueIconContainer: {
    display: 'flex',
    width: '20%',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  venueIcon: {
    width: 25,
  },
  venueLabel: {
    fontSize: '14px',
    fontWeight: 500,
  },
  venueContent: {
  },
  venueText: {
    fontSize: '14px',
    fontWeight: 500,
    paddingLeft: '10px',
  }
}));
